import { __decorate } from "tslib";
import { attr, nullableNumberConverter } from "@microsoft/fast-element";
import { FluentHorizontalScroll } from "@fluentui/web-components";
export class Stripe extends FluentHorizontalScroll {
    constructor() {
        super(...arguments);
        /**
         * Updating the scroll speed to a default of 1200
         */
        this.speed = 1200;
        /**
         * The title heading level, default = 3
         */
        this.headingLevel = 3;
    }
}
__decorate([
    attr
], Stripe.prototype, "speed", void 0);
__decorate([
    attr({
        attribute: "heading-level",
        mode: "fromView",
        converter: nullableNumberConverter,
    })
], Stripe.prototype, "headingLevel", void 0);
__decorate([
    attr
], Stripe.prototype, "heading", void 0);
